const types = {
  RESET_LANDING_TEMPLATE_STATE: 'RESET_LANDING_TEMPLATE_STATE',
  SYNC_LANDING_TEMPLATES: {
    REQUEST: 'SYNC_LANDING_TEMPLATES.REQUEST',
    SUCCESS: 'SYNC_LANDING_TEMPLATES.SUCCESS',
    FAILURE: 'SYNC_LANDING_TEMPLATES.FAILURE',
  },
  SAVE_LANDING_TEMPLATE: {
    REQUEST: 'SAVE_LANDING_TEMPLATE.REQUEST',
    SUCCESS: 'SAVE_LANDING_TEMPLATE.SUCCESS',
    FAILURE: 'SAVE_LANDING_TEMPLATE.FAILURE',
  },
  ARCHIVE_LANDING_TEMPLATE: {
    REQUEST: 'ARCHIVE_LANDING_TEMPLATE.REQUEST',
    SUCCESS: 'ARCHIVE_LANDING_TEMPLATE.SUCCESS',
    FAILURE: 'ARCHIVE_LANDING_TEMPLATE.FAILURE',
  },
};

export default types;
